export enum CommonSelectors {
  ConfigPanel = 'div.config-panel > .scroll-area',
  SelectableInputs = 'input, textarea, button.dropdown-toggle, label',
}

export enum CommonComponents {
  FieldWithErrors = `<div class=field_with_errors></div>`
}